import React from 'react';
import axios from 'axios';
// import Page from 'components/Page';
import { Col, Row, Table, Modal, ModalBody, ModalHeader, Form, Input, Label, Button, FormGroup } from 'reactstrap';
// import ReactConfirmAlert, { confirmAlert } from 'react-confirm-alert';
import { Chip, Fab } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';
// import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import 'react-confirm-alert/src/react-confirm-alert.css';
// import PropTypes from 'prop-types';
// import ReactPaginate from 'react-paginate';
import $ from 'jquery';
import { NavLink } from 'react-router-dom';
// import moment from 'moment';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Typeahead } from 'react-bootstrap-typeahead';

const MySwal = withReactContent(Swal);
const token_id = localStorage.getItem('token');


// แปลงค่าระดับความเสี่ยงเป็นสี/ข้อความ
function Risk({ value }) {
  let color;
  let text;
  if (value <= 5) {
    color = '#99CC66';
    text = 'ต่ำ';
  } else if (value <= 9) {
    color = '#FFEE66';
    text = 'ปานกลาง';
  } else if (value <= 15) {
    color = '#FFCC66';
    text = 'สูง';
  } else if (value <= 25) {
    color = '#EE4444';
    text = 'สูงมาก';
  }
  return <Chip style={{ backgroundColor: color, fontWeight: '600' }} label={text} />;
}

export default class EditProjectRiskData extends React.Component {
  constructor(props) {
    super(props);
    let id;
this.props.page === ':id' || this.props.page === '' || (this.props.page === null || this.props.page === undefined) ? (id = 1) : (id = this.props.page);

    this.state = {
      Budget: [],
      ButgetSources: [],
      refreshing: false,
      modal: false,
      ID: id,
      isForm: '',
      data: [],
      data1: [],
      selected: 1,
      currenpage: id - 1,
      offset: 0,
      perPage: 10,
      keyword: '',
      url: process.env.REACT_APP_SOURCE_URL + '/projectEquipments/risks/' + id,

      projectId: id,
      riskId: '',
      riskDetail: '',
      riskLikelihood: '',
      riskImpact: '',
      riskReduction: '',
      riskStatus: '',
      riskCode: '',
      riskTypes: [],
      riskTypeOptions: [
        { id: 1, label: 'ความเสี่ยงด้านกลยุทธ์' },
        { id: 2, label: 'ความเสี่ยงด้านการเงิน' },
        { id: 3, label: 'ความเสี่ยงด้านการดำเนินงาน' },
        { id: 4, label: 'ความเสี่ยงด้านการปฏิบัติตามกฎหมาย' },
        { id: 5, label: 'ความเสี่ยงด้านเทคโนโลยีสารสนเทศ' },
        { id: 6, label: 'ความเสี่ยงด้านความน่าเชื่อถือขององค์กร' },
      ],
      showTypeMenu: false,

      // validate
      validationError: '',
      validationError1: '',
      validationError2: '',
      validationError3: '',
      validationError4: '',
      validationErrorCode: '',
      validationErrorTypes: '',
    };
  }

  // เมนูเลือกประเภท
  toggleTypeMenu = () => this.setState(prev => ({ showTypeMenu: !prev.showTypeMenu }));

  addRiskType = type => {
    this.setState(prev => {
      if (prev.riskTypes.includes(type)) return { showTypeMenu: false }; // ไม่ซ้ำ
      return { riskTypes: [...prev.riskTypes, type], showTypeMenu: false, validationErrorTypes: '' };
    });
  };

  removeRiskType = type =>
    this.setState(prev => ({
      riskTypes: prev.riskTypes.filter(t => t !== type),
    }));

  toggle = modalType => () => {
    if (!modalType) {
      return this.setState({
        modal: !this.state.modal,
        showTypeMenu: false,
      });
    }
    this.setState({
      [`modal_${modalType}`]: !this.state[`modal_${modalType}`],
    });
  };

  _onRefresh = () => {
    this.setState({ refreshing: true });
    this.loadCommentsFromServer().then(() => {
      this.setState({ refreshing: false });
    });
  };

  testAxiosDELETE = id => {
    if (id !== undefined) {
      MySwal.fire({
        title: <strong>คุณต้องการจะลบข้อมูลนี้</strong>,
        icon: 'warning',
        confirmButtonColor: '#66BB66',
        confirmButtonText: 'ยืนยัน',
        showCancelButton: true,
        cancelButtonColor: '#EE4444',
        cancelButtonText: 'ยกเลิก',
      }).then(result => {
        if (result.isConfirmed) {
          this.DELETE(id);
        }
      });
    } else {
      MySwal.fire({
        title: <strong>ไม่พบ Risk ID</strong>,
        html: <i>กรุณาลองใหม่อีกครั้ง</i>,
        icon: 'error',
        confirmButtonColor: '#66BB66',
        showConfirmButton: false,
        timer: 1000,
      });
    }
  };

  DELETE = id => {
    axios
      .delete(process.env.REACT_APP_SOURCE_URL + '/projectEquipments/risks/risks/' + id)
      .then(res => {
        MySwal.fire({
          title: <strong>ลบข้อมูลสำเร็จ</strong>,
          icon: 'success',
          showConfirmButton: false,
          timer: 1000,
        });
        this.loadCommentsFromServer();
      })
      .catch(err => {
        console.log(err);
      });
  };

  onEdit = id => {
    axios.get(process.env.REACT_APP_SOURCE_URL + '/projectEquipments/risks/risks/' + id).then(res => {
      const { project_id, risk_id, risk_detail, risk_likelihood, risk_impact, risk_reduction, risk_code, risk_type } = res.data.result;

      const typesAsIds = this.parseRiskTypeToIds(risk_type); // << แปลงเป็นไอดี

      this.setState({
        modal: true,
        isForm: 'edit',
        ID: project_id,
        header: 'แก้ไขข้อมูลความเสี่ยง',
        projectId: project_id,
        riskId: risk_id,
        riskDetail: risk_detail,
        riskLikelihood: risk_likelihood,
        riskImpact: risk_impact,
        riskReduction: risk_reduction,
        riskCode: risk_code || '',
        riskTypes: typesAsIds,
        validationError: '',
        validationError1: '',
        validationError2: '',
        validationError3: '',
        validationError4: '',
        validationErrorCode: '',
        validationErrorTypes: '',
      });
    });
  };

  handleInputChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onAdd() {
    this.setState({
      modal: true,
      isForm: '',
      riskId: '',
      riskDetail: '',
      riskLikelihood: '',
      riskImpact: '',
      riskReduction: '',
      riskCode: '',
      riskTypes: [],
      showTypeMenu: false,

      validationError: '',
      validationError1: '',
      validationError2: '',
      validationError3: '',
      validationError4: '',
      validationErrorCode: '',
      validationErrorTypes: '',
      header: 'เพิ่มข้อมูลความเสี่ยง',
    });
  }

  handleSubmit = e => {
    e.preventDefault();
    if (this.state.isForm === 'edit') {
      this.handleUpdate(e);
    } else {
      this.handleSubmit1(e);
    }
  };

  // เพิ่ม
  handleSubmit1 = e => {
    e.preventDefault();
    const valid = this.state.riskCode.trim() && this.state.riskTypes.length > 0 && this.state.riskDetail.trim() && this.state.riskLikelihood && this.state.riskImpact && this.state.riskReduction;

    if (valid) {
      axios
        .post(
          process.env.REACT_APP_SOURCE_URL + '/projectEquipments/risks/' + this.state.projectId,
          {
            risk_code: this.state.riskCode,
            risk_type: this.state.riskTypes, // << [1,2]
            risk_detail: this.state.riskDetail,
            risk_likelihood: this.state.riskLikelihood,
            risk_impact: this.state.riskImpact,
            risk_reduction: this.state.riskReduction,
          },
          { headers: { Authorization: `Bearer ${token_id}` } },
        )
        .then(res => {
          MySwal.fire({
            title: <strong>บันทึกข้อมูลสำเร็จ</strong>,
            icon: 'success',
            timer: 1000,
            showConfirmButton: false,
          });
          this.setState({ modal: false });
          this.loadCommentsFromServer();
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      const errCode = this.state.riskCode.trim() ? '' : 'กรุณากรอกรหัสความเสี่ยง';
      const errTypes = this.state.riskTypes.length > 0 ? '' : 'กรุณาเลือกอย่างน้อย 1 ประเภท';
      const validationError1 = this.state.riskDetail.trim() ? '' : 'กรุณากรอกข้อมูลให้ครบถ้วน';
      const validationError2 = this.state.riskLikelihood ? '' : 'กรุณากรอกข้อมูลให้ครบถ้วน';
      const validationError3 = this.state.riskImpact ? '' : 'กรุณากรอกข้อมูลให้ครบถ้วน';
      const validationError4 = this.state.riskReduction ? '' : 'กรุณากรอกข้อมูลให้ครบถ้วน';

      this.setState({
        validationErrorCode: errCode,
        validationErrorTypes: errTypes,
        validationError1,
        validationError2,
        validationError3,
        validationError4,
      });
    }
  };

  // แก้ไข
  handleUpdate = e => {
    e.preventDefault();
    const ID = this.state.riskId;

    const valid = this.state.riskCode.trim() && this.state.riskTypes.length > 0 && this.state.riskDetail.trim() && this.state.riskLikelihood && this.state.riskImpact && this.state.riskReduction;

    if (valid) {
      axios
        .patch(
          process.env.REACT_APP_SOURCE_URL + '/projectEquipments/risks/' + ID,
          {
            risk_code: this.state.riskCode,
            risk_type: this.state.riskTypes,
            risk_detail: this.state.riskDetail,
            risk_likelihood: this.state.riskLikelihood,
            risk_impact: this.state.riskImpact,
            risk_reduction: this.state.riskReduction,
            risk_status: 1,
          },
          { headers: { Authorization: `Bearer ${token_id}` } },
        )
        .then(res => {
          MySwal.fire({
            title: <strong>แก้ไขข้อมูลสำเร็จ</strong>,
            icon: 'success',
            timer: 1000,
            showConfirmButton: false,
          });
          this.setState({ modal: false });
          this.loadCommentsFromServer();
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      const errCode = this.state.riskCode.trim() ? '' : 'กรุณากรอกรหัสความเสี่ยง';
      const errTypes = this.state.riskTypes.length > 0 ? '' : 'กรุณาเลือกอย่างน้อย 1 ประเภท';
      const validationError1 = this.state.riskDetail.trim() ? '' : 'กรุณากรอกข้อมูลให้ครบถ้วน';
      const validationError2 = this.state.riskLikelihood ? '' : 'กรุณากรอกข้อมูลให้ครบถ้วน';
      const validationError3 = this.state.riskImpact ? '' : 'กรุณากรอกข้อมูลให้ครบถ้วน';
      const validationError4 = this.state.riskReduction ? '' : 'กรุณากรอกข้อมูลให้ครบถ้วน';

      this.setState({
        validationErrorCode: errCode,
        validationErrorTypes: errTypes,
        validationError1,
        validationError2,
        validationError3,
        validationError4,
      });
    }
  };

  componentDidMount() {
    this.toggle();
    this.loadCommentsFromServer();
  }

  loadCommentsFromServer() {
    $.ajax({
      url: this.state.url + '?page=' + this.state.selected + '&size=' + this.state.perPage + '&search=' + this.state.keyword,
      data: {
        totalPage: this.state.perPage,
        offset: this.state.offset,
      },
      dataType: 'json',
      type: 'GET',
      success: data => {
        this.setState({
          data: data.result,
        });
      },
      error: (xhr, status, err) => {
        console.error(this.state.url, status, err.toString());
      },
    });
  }

  handlePageClick = data => {
    let selected = data.selected + 1;
    let offset = Math.ceil(selected * this.state.perPage);
    this.setState({ offset: offset, selected: selected }, () => {
      this.loadCommentsFromServer();
    });
  };

  handleInputChangeNumber = e => {
    var value = NaN;
    if (parseInt(e.target.value) >= 0 && parseInt(e.target.value).toString() !== 'NaN') {
      if (parseInt(e.target.value) > 5) {
        if (e.target.name === 'riskLikelihood') {
          this.setState({ validationError2: 'กรุณากรอก 1-5' });
        }
        if (e.target.name === 'riskImpact') {
          this.setState({ validationError3: 'กรุณากรอก 1-5' });
        }
      } else {
        if (e.target.name === 'riskLikelihood') {
          this.setState({ validationError2: '' });
        }
        if (e.target.name === 'riskImpact') {
          this.setState({ validationError3: '' });
        }
        value = e.target.value;
      }
    }
    this.setState({
      [e.target.name]: value.toString(),
    });
  };

  hoverTable = id => {
    document.getElementById(id).classList.add('hover-tb');
  };
  outHoverTable = id => {
    document.getElementById(id).classList.remove('hover-tb');
  };
  showRisk = id => {
    for (let index = 1; index <= 5; index++) {
      for (let index1 = 1; index1 <= 5; index1++) {
        if (index.toString() + index1.toString() !== id) {
          document.getElementById(index.toString() + index1.toString()).classList.add('hightlight');
        }
      }
    }
  };
  hideRisk = id => {
    for (let index = 1; index <= 5; index++) {
      for (let index1 = 1; index1 <= 5; index1++) {
        if (index.toString() + index1.toString() !== id) {
          document.getElementById(index.toString() + index1.toString()).classList.remove('hightlight');
        }
      }
    }
  };

  // แปลงประเภทจาก record (string/array) -> array สำหรับแสดงผล
  normalizeTypes = value => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') {
      return value
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
    }
    return [];
  };
  typeIdToLabel = id => {
    const opt = this.state.riskTypeOptions.find(o => String(o.id) === String(id));
    return opt ? opt.label : String(id);
  };
  parseRiskTypeToIds = value => {
    if (!value) return [];
    const labelToId = label => {
      const f = this.state.riskTypeOptions.find(o => o.label === label);
      return f ? f.id : NaN;
    };

    const toIds = arr =>
      arr
        .map(v => {
          // เป็น object {id,label}
          if (v && typeof v === 'object') return v.id;
          // เป็นตัวเลขหรือตัวเลขในรูป string
          const n = parseInt(v, 10);
          if (!isNaN(n)) return n;
          // เป็น label (ข้อความ)
          const byLabel = labelToId(String(v).trim());
          return byLabel;
        })
        .filter(id => !isNaN(id));

    if (Array.isArray(value)) return toIds(value);

    if (typeof value === 'string') {
      // แยกด้วย comma
      const parts = value
        .split(',')
        .map(s => s.trim())
        .filter(Boolean);
      return toIds(parts);
    }
    return [];
  };

  // นำค่าจาก record (อาจเป็น id/ข้อความ/สตริง) มาแปลงเป็น "อาร์เรย์ข้อความ" เพื่อแสดงผล
  formatRiskTypeForDisplay = value => {
    const ids = this.parseRiskTypeToIds(value);
    return ids.map(this.typeIdToLabel);
  };
  render() {
    return (
      <>
        <Row>
          <Col sm={12}>
            <div className="box-9">ตารางความเสี่ยง</div>
          </Col>

          {/* ตารางเมทริกซ์คงเดิม */}
          <Col>
            {/* ... (คงโค้ดตารางเมทริกซ์ตามเดิมทั้งหมด) ... */}
            <table className="tg">
              <thead>
                <tr>
                  <th className="tg-ymo1" rowSpan="2">
                    ผลกระทบ
                  </th>
                  <th className="tg-as3b" colSpan="5">
                    โอกาสเกิด
                  </th>
                </tr>
                <tr>
                  <th className="tg-aw58">ระดับ 1</th>
                  <th className="tg-1e0e">
                    <span>ระดับ 2</span>
                  </th>
                  <th className="tg-4mqo">
                    <span>ระดับ 3</span>
                  </th>
                  <th className="tg-h7u1">
                    <span>ระดับ 4</span>
                  </th>
                  <th className="tg-0uq8">
                    <span>ระดับ 5</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="tg-ymo1">
                    <span>ระดับ 5</span>
                  </td>
                  <td id="15" className="tg-7o62">
                    <span>ต่ำ</span>
                  </td>
                  <td id="25" className="tg-jp6u">
                    <span>สูง</span>
                  </td>
                  <td id="35" className="tg-jp6u">
                    <span>สูง</span>
                  </td>
                  <td id="45" className="tg-cvi2">
                    <span>สูงมาก</span>
                  </td>
                  <td id="55" className="tg-cvi2">
                    <span>สูงมาก</span>
                  </td>
                </tr>
                <tr>
                  <td className="tg-ymo1">
                    <span>ระดับ 4</span>
                  </td>
                  <td id="14" className="tg-7o62">
                    <span>ต่ำ</span>
                  </td>
                  <td id="24" className="tg-arcq">
                    <span>ปานกลาง</span>
                  </td>
                  <td id="34" className="tg-jp6u">
                    <span>สูง</span>
                  </td>
                  <td id="44" className="tg-cvi2">
                    <span>สูงมาก</span>
                  </td>
                  <td id="54" className="tg-cvi2">
                    <span>สูงมาก</span>
                  </td>
                </tr>
                <tr>
                  <td className="tg-ymo1">
                    <span>ระดับ 3</span>
                  </td>
                  <td id="13" className="tg-7o62">
                    ต่ำ
                  </td>
                  <td id="23" className="tg-arcq">
                    <span>ปานกลาง</span>
                  </td>
                  <td id="33" className="tg-arcq">
                    <span>ปานกลาง</span>
                  </td>
                  <td id="43" className="tg-jp6u">
                    <span>สูง</span>
                  </td>
                  <td id="53" className="tg-jp6u">
                    <span>สูง</span>
                  </td>
                </tr>
                <tr>
                  <td className="tg-ymo1">
                    <span>ระดับ 2</span>
                  </td>
                  <td id="12" className="tg-7o62">
                    <span>ต่ำ</span>
                  </td>
                  <td id="22" className="tg-7o62">
                    <span>ต่ำ</span>
                  </td>
                  <td id="32" className="tg-arcq">
                    <span>ปานกลาง</span>
                  </td>
                  <td id="42" className="tg-arcq">
                    <span>ปานกลาง</span>
                  </td>
                  <td id="52" className="tg-jp6u">
                    <span>สูง</span>
                  </td>
                </tr>
                <tr>
                  <td className="tg-ymo1">
                    <span>ระดับ 1</span>
                  </td>
                  <td id="11" className="tg-7o62">
                    <span>ต่ำ</span>
                  </td>
                  <td id="21" className="tg-7o62">
                    <span>ต่ำ</span>
                  </td>
                  <td id="31" className="tg-7o62">
                    <span>ต่ำ</span>
                  </td>
                  <td id="41" className="tg-7o62">
                    <span>ต่ำ</span>
                  </td>
                  <td id="51" className="tg-7o62">
                    <span>ต่ำ</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>

          <Col sm={12}>
            <div className="box-9">ข้อมูลความเสี่ยง</div>
          </Col>

          {/* ตารางผลลัพธ์ – เพิ่มคอลัมน์ รหัส และ ประเภท */}
          <Col>
            <Table responsive borderless id="table1">
              <thead>
                <tr style={{ backgroundColor: '#e0ecfa' }}>
                  <th style={{ textAlign: 'center' }}>ลำดับ</th>
                  <th style={{ textAlign: 'center' }}>รหัสความเสี่ยง</th>
                  <th style={{ textAlign: 'left' }}>ประเด็นความเสี่ยง</th>
                  <th style={{ textAlign: 'left' }}>ประเภทความเสี่ยง</th>
                  <th style={{ textAlign: 'center' }}>โอกาสเกิด</th>
                  <th style={{ textAlign: 'center' }}>ผลกระทบ</th>
                  <th style={{ textAlign: 'center' }}>ระดับความเสี่ยง</th>
                  <th style={{ textAlign: 'center' }}>จัดการข้อมูล</th>
                </tr>
              </thead>
              <tbody>
                {this.state.data.length === 0 ? (
                  <tr>
                    <td colSpan="8" align="center">
                      ไม่มีข้อมูล
                    </td>
                  </tr>
                ) : (
                  this.state.data.map((id, i) => {
                    // const types = this.normalizeTypes(id.risk_type);
                    const labels = this.formatRiskTypeForDisplay(id.risk_type); // << ได้เป็น array ของข้อความแล้ว
                    return (
                      <tr
                        id={'tr' + i}
                        key={'table' + i}
                        onMouseOver={() => {
                          this.showRisk(id.risk_likelihood.toString() + id.risk_impact.toString());
                          this.hoverTable('tr' + i);
                        }}
                        onMouseOut={() => {
                          this.hideRisk(id.risk_likelihood.toString() + id.risk_impact.toString());
                          this.outHoverTable('tr' + i);
                        }}
                      >
                        <td style={{ textAlign: 'center' }}>{i + 1}</td>
                        <td style={{ textAlign: 'center' }}>{id.risk_code || '-'}</td>
                        <td style={{ textAlign: 'left' }}>{id.risk_detail}</td>

                        <td style={{ textAlign: 'left' }}>
                          {labels.length === 0
                            ? '-'
                            : labels.map((t, idx) => (
                                <Chip
                                  key={idx}
                                  label={t}
                                  style={{
                                    marginRight: 6,
                                    marginBottom: 6,
                                    backgroundColor: '#e3f2ff',
                                    fontWeight: 500,
                                  }}
                                />
                              ))}
                        </td>
                        <td style={{ textAlign: 'center' }}>{id.risk_likelihood}</td>
                        <td style={{ textAlign: 'center' }}>{id.risk_impact}</td>
                        <td style={{ textAlign: 'center' }}>
                          <Risk value={id.risk_likelihood * id.risk_impact} />
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          <Tooltip title="แก้ไข">
                            <span className="edit-button" onClick={() => this.onEdit(id.risk_id)}>
                              <Icon style={{ fontSize: '14px' }}>edit</Icon>
                            </span>
                          </Tooltip>
                          &nbsp;
                          <Tooltip title="ลบ">
                            <span className="delete-button" onClick={() => this.testAxiosDELETE(id.risk_id)}>
                              <Icon style={{ fontSize: '14px' }}>delete_outline</Icon>
                            </span>
                          </Tooltip>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>

            <div style={{ display: 'flex', justifyContent: 'right' }}>
              <NavLink to={`/AllProject/EditProject3/${this.state.projectId}`}>{'ข้อมูลตัวชี้วัด <<'}</NavLink>
              <div className="box-10">{'หน้าก่อน'}</div>
            </div>

            {/* MODAL เพิ่ม/แก้ไข */}
            <Modal isOpen={this.state.modal} toggle={this.toggle()} className={this.props.className}>
              <ModalHeader
                toggle={this.toggle()}
                style={{
                  backgroundColor: '#e0ecfa',
                  borderTopLeftRadius: '1.5rem',
                  borderTopRightRadius: '1.5rem',
                }}
              >
                {this.state.header}
              </ModalHeader>
              <ModalBody style={{ borderRadius: '1.5rem' }}>
                <Form onSubmit={this.handleSubmit}>
                  <FormGroup>
                    {/* รหัสความเสี่ยง */}
                    <Label sm={12}>
                      รหัสความเสี่ยง <font color="red">*</font> :
                    </Label>
                    <Col sm={12}>
                      <Input type="text" name="riskCode" onChange={this.handleInputChange} value={this.state.riskCode} />
                    </Col>
                    <Col sm={12} style={{ color: 'red', marginTop: 5 }}>
                      {this.state.validationErrorCode}
                    </Col>

                    {/* ประเด็นความเสี่ยง */}
                    <Label sm={12} style={{ marginTop: 10 }}>
                      ประเด็นความเสี่ยง <font color="red">*</font> :
                    </Label>
                    <Col sm={12}>
                      <Input type="textarea" name="riskDetail" onChange={this.handleInputChange} value={this.state.riskDetail} />
                    </Col>
                    <Col sm={12} style={{ color: 'red', marginTop: 5 }}>
                      {this.state.validationError1}
                    </Col>

                    <Label sm={12} style={{ marginTop: 10 }}>
                      ประเภทความเสี่ยง <font color="red">*</font> :
                    </Label>
                    <Col sm={12}>
                      <Typeahead
                        id="risk-type"
                        multiple
                        clearButton
                        labelKey="label"
                        options={this.state.riskTypeOptions}
                        selected={this.state.riskTypeOptions.filter(o => this.state.riskTypes.includes(o.id))}
                        onChange={selected =>
                          this.setState({
                            riskTypes: selected.map(s => s.id),
                            validationErrorTypes: '',
                          })
                        }
                        placeholder="เลือกประเภท"
                        flip
                      />
                    </Col>
                    <Col sm={12} style={{ color: 'red', marginTop: 5 }}>
                      {this.state.validationErrorTypes}
                    </Col>

                    {/* โอกาสเกิด / ผลกระทบ */}
                    <Label sm={12} style={{ marginTop: 10 }}>
                      โอกาสเกิด <font color="red"> * ( 1 - 5 ) </font> :
                    </Label>
                    <Col sm={12}>
                      <Input type="number" name="riskLikelihood" max={5} min={0} onChange={this.handleInputChangeNumber} value={this.state.riskLikelihood} />
                    </Col>
                    <Col sm={12} style={{ color: 'red', marginTop: 5 }}>
                      {this.state.validationError2}
                    </Col>

                    <Label sm={12}>
                      ผลกระทบ <font color="red"> * ( 1 - 5 ) </font> :
                    </Label>
                    <Col sm={12}>
                      <Input type="number" name="riskImpact" max={5} min={0} onChange={this.handleInputChangeNumber} value={this.state.riskImpact} />
                    </Col>
                    <Col sm={12} style={{ color: 'red', marginTop: 5 }}>
                      {this.state.validationError3}
                    </Col>

                    {/* แนวทางลดความเสี่ยง */}
                    <Label sm={12}>
                      แนวทางการลดความเสี่ยง <font color="red">*</font> :
                    </Label>
                    <Col sm={12}>
                      <Input type="textarea" name="riskReduction" onChange={this.handleInputChange} value={this.state.riskReduction} />
                    </Col>
                    <Col sm={12} style={{ color: 'red', marginTop: 5 }}>
                      {this.state.validationError4}
                    </Col>
                  </FormGroup>

                  <FormGroup style={{ textAlign: 'center' }}>
                    <Button color="success">บันทึก</Button>&nbsp;
                    <Button color="danger" onClick={this.toggle()}>
                      ยกเลิก
                    </Button>
                  </FormGroup>
                </Form>
              </ModalBody>
            </Modal>
          </Col>
        </Row>
        {this.props.basename[1] === 'AllProjectArticles' && (
          <div className="floating-button">
            <Tooltip title="Add">
              <Fab
                className="btn_not_focus"
                style={{
                  border: '10px solid #3f51b5',
                  backgroundColor: '#fff',
                  width: '70px',
                  height: '70px',
                }}
                onClick={() => this.onAdd()}
              >
                <Icon color="primary">add</Icon>
              </Fab>
            </Tooltip>
          </div>
        )}
      </>
    );
  }
}
